export type MonthlyFilterKey = 'shootStatus' | 'contractType' | 'data' | 'tmCategory' | 'tmStatus'

export type MonthlyFilterOption = {
  id: string
  label: string
  disabled?: boolean
  queryValue?: string
}

export type MonthlyMockEntry = {
  id: string
  day: number
  kind: 'photo' | 'normal' | 'work' | 'tm' | 'memo' | 'due' | 'birthday' | 'party'
  time?: string
  label: string
  color?: string
  shootStatus?: string
  contractType?: string
  tmCategory?: string
  tmStatus?: string
  businessTrip?: boolean
  customerId?: string
}

export type MonthlyDetailEntry = {
  id: string
  category: 'other' | 'photo' | 'work' | 'tm'
  dataKey: 'due' | 'photo' | 'work' | 'tm'
  label: string
  color: string
  customerId: string
  shootStatus?: string
  contractType?: string
  tmCategory?: string
  tmStatus?: string
}

export const legacyMonthlyOffices = [
  { id: 'mock-office', name: 'Mock 지점' },
  { id: 'mock-office-b', name: 'Mock 지점 B' },
]

export const legacyMonthlyShootStatusOptions: MonthlyFilterOption[] = [
  { id: 'all', label: '모두' },
  { id: '105', label: '미완료' },
  { id: '106', label: '완료' },
  { id: '107', label: '연기' },
  { id: '108', label: '취소' },
  { id: '109', label: '변경' },
  { id: '110', label: '노쇼' },
  { id: '111', label: '2주' },
  { id: '112', label: 'OK' },
]

export const legacyMonthlyContractOptions: MonthlyFilterOption[] = [
  { id: 'all', label: '모두' },
  { id: '0', label: '미지정' },
  { id: '1', label: '신규' },
  { id: '2', label: '계약' },
  { id: '3', label: '보류' },
]

export const legacyMonthlyDataOptions: MonthlyFilterOption[] = [
  { id: 'all', label: '모두' },
  { id: 'photo', label: '촬영스케줄' },
  { id: 'normal', label: '일반일정' },
  { id: 'work', label: '업무일지' },
  { id: 'tm', label: 'TM스케줄', disabled: true },
  { id: 'due', label: '출산예정일' },
  { id: 'birthday', label: '출생일' },
  { id: 'party', label: '돌잔치' },
  { id: 'memo', label: '메모' },
  { id: 'trip', label: '출장촬영만' },
]

export const legacyMonthlyTmCategoryOptions: MonthlyFilterOption[] = [
  { id: 'tm_category_all', label: '모두' },
  ...['1', '3', '5', '6', '7', '8', '12', '13', '14'].map((id, index) => ({ id, label: `Mock TM 항목 ${String(index + 1).padStart(2, '0')}` })),
]

export const legacyMonthlyTmStatusOptions: MonthlyFilterOption[] = [
  { id: 'tm_status_all', label: '모두' },
  { id: '0,1', queryValue: '0,1', label: '미완료' },
  { id: '2', label: 'Mock 상태 02' },
  { id: '5', label: 'Mock 상태 05' },
  { id: '6', label: 'Mock 상태 06' },
  { id: '3', label: 'Mock 상태 03' },
  { id: '7', label: 'Mock 상태 07' },
  { id: '4', label: 'Mock 상태 04' },
]

export const legacyMonthlyFilterGroups: Array<{ key: MonthlyFilterKey; title: string; options: MonthlyFilterOption[] }> = [
  { key: 'shootStatus', title: '촬영 스케줄 상태', options: legacyMonthlyShootStatusOptions },
  { key: 'contractType', title: '계약 구분', options: legacyMonthlyContractOptions },
  { key: 'data', title: '표시할 데이터', options: legacyMonthlyDataOptions },
  { key: 'tmCategory', title: 'TM 항목', options: legacyMonthlyTmCategoryOptions },
  { key: 'tmStatus', title: 'TM 상태', options: legacyMonthlyTmStatusOptions },
]

export const legacyMonthlyContractSummary = Array.from({ length: 35 }, (_, index) => ({
  id: `mock-contract-${index + 1}`,
  name: `Mock 유형 ${String(index + 1).padStart(2, '0')}`,
  count: (index % 5) + 1,
}))

export const legacyMonthlyHolidays = [
  { month: 8, day: 15, name: '광복절' },
]

export const legacyMonthlyMockEntries: MonthlyMockEntry[] = [
  { id: 'm-01', day: 1, kind: 'photo', time: '10:00', label: 'Mock 촬영 일정', color: '#f27b38', shootStatus: '105', contractType: '0', customerId: 'mock-customer-01' },
  { id: 'm-02', day: 1, kind: 'tm', label: 'Mock TM 일정', color: '#1c2024', tmCategory: '1', tmStatus: '0,1', customerId: 'mock-customer-02' },
  { id: 'm-03', day: 2, kind: 'work', label: 'Mock 업무 일정', color: '#00a69b' },
  { id: 'm-04', day: 3, kind: 'photo', time: '13:00', label: 'Mock 촬영 일정', color: '#f27b38', shootStatus: '106', contractType: '1', businessTrip: true, customerId: 'mock-customer-03' },
  { id: 'm-05', day: 4, kind: 'memo', label: 'Mock 메모', color: '#60646c' },
  { id: 'm-06', day: 6, kind: 'due', label: '출산 예정일 · Mock', color: '#ff69b4', customerId: 'mock-customer-04' },
  { id: 'm-07', day: 8, kind: 'photo', time: '11:00', label: 'Mock 촬영 일정', color: '#f27b38', shootStatus: '107', contractType: '2', customerId: 'mock-customer-05' },
  { id: 'm-08', day: 10, kind: 'normal', label: 'Mock 일반 일정', color: '#7657cf' },
  { id: 'm-09', day: 12, kind: 'work', label: 'Mock 업무 일정', color: '#00a69b' },
  { id: 'm-10', day: 15, kind: 'photo', time: '15:00', label: 'Mock 촬영 일정', color: '#f27b38', shootStatus: '108', contractType: '3', customerId: 'mock-customer-06' },
  { id: 'm-11', day: 18, kind: 'memo', label: 'Mock 메모', color: '#60646c' },
  { id: 'm-12', day: 20, kind: 'normal', label: 'Mock 일반 일정', color: '#7657cf' },
  { id: 'm-13', day: 21, kind: 'birthday', label: 'Mock 출생일', color: '#e266a0', customerId: 'mock-customer-07' },
  { id: 'm-14', day: 23, kind: 'party', label: 'Mock 돌잔치', color: '#7657cf', customerId: 'mock-customer-08' },
  { id: 'm-15', day: 25, kind: 'tm', label: 'Mock TM 일정', color: '#1c2024', tmCategory: '3', tmStatus: '2', customerId: 'mock-customer-09' },
  { id: 'm-16', day: 28, kind: 'photo', time: '14:00', label: 'Mock 촬영 일정', color: '#f27b38', shootStatus: '112', contractType: '2', customerId: 'mock-customer-10' },
]

export const legacyMonthlyDetailEntries: MonthlyDetailEntry[] = [
  { id: 'detail-01', category: 'other', dataKey: 'due', label: '출산예정일 · Mock', color: '#e266a0', customerId: 'mock-customer-01' },
  { id: 'detail-02', category: 'photo', dataKey: 'photo', label: '10:00  Mock 촬영 일정', color: '#f27b38', customerId: 'mock-customer-02', shootStatus: '105', contractType: '0' },
  { id: 'detail-03', category: 'photo', dataKey: 'photo', label: '13:00  Mock 촬영 일정', color: '#7657cf', customerId: 'mock-customer-03', shootStatus: '106', contractType: '1' },
  { id: 'detail-04', category: 'work', dataKey: 'work', label: 'Mock 업무 일정', color: '#00a69b', customerId: 'mock-customer-04' },
  { id: 'detail-05', category: 'tm', dataKey: 'tm', label: 'Mock TM 일정', color: '#1c2024', customerId: 'mock-customer-05', tmCategory: '1', tmStatus: '0,1' },
]
